import { render, staticRenderFns } from "./PracticeIndex.vue?vue&type=template&id=e7760378&"
import script from "./PracticeIndex.vue?vue&type=script&lang=js&"
export * from "./PracticeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports